import { Injectable, ElementRef } from '@angular/core';

@Injectable()
export class WindowRef {
  public static readonly LARGE_WIDTH: number = 1000;

  public isLarge: boolean;
  public content: any;

  public get nativeWindow() {
    return window;
  }

  public open(url: string, target: string = "_tab") {
    window.open(url, target);
  }

  public safeOpen(url: string, target: string = "_tab", download?: string) {
    let a = document.createElement('a');

    a.href = url;
    a.target = target;

    if (download) {
      a.download = download;
    }

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  public reload(forcedReload: boolean = false) {
    window.location.reload(forcedReload);
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/services/window-ref.ts